/** axios封装 **/
import axios from "axios";
import { axiosConfig } from "./axiosConfig";
import { Message, MessageBox } from "element-ui";
import { stringify } from "qs";
import store from "@/store/index";
import { WAP_INDEX } from "@/utils/constants/constants";
import { renderCaptcha } from "@/utils/captcha";
import { CookieKeys, Cookies } from "./cookieKey";
import { clearCookies, PROXY_TYPE } from "@/utils/common";

function getHeaders() {
  return {
    "Access-Captcha-Permission": Cookies.get("accessCaptchaPermission") || "None",
    // "nowUrl": document.location.href,
  };
}

async function handleSuccessResponse(res, config) {
  if (res.status === axiosConfig.HTTP_CODE.SUCCESS) {
    /** 判断业务code **/
    const code = parseInt(res.data.code);

    switch (code) {
      /** code 为 200 **/
      case axiosConfig.STATUS_CODE.SUCCESS:
        // x-auth-token从响应头取值，注入cookie
        if (res.headers["x-auth-token"]) {
          if (store.getters["configInfo/configInfoObj"].ui === "pc") {
            Cookies.set(CookieKeys.xAuthToken, res.headers["x-auth-token"], { domain: ".qianlima.com" });
          } else {
            Cookies.set(CookieKeys.authToken, res.headers["x-auth-token"], { domain: ".qianlima.com" });
          }
        }
        return Promise.resolve(res.data);

      case axiosConfig.STATUS_CODE.TRY_PSD_LOGIN:
        MessageBox.confirm(res.data.msg, "获取验证码失败", {
          confirmButtonText: "密码登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            window.location.href =
              store.getters["basic/platform"] === "mobile" ? WAP_INDEX : process.env["VUE_APP_HOME_URL_1.0"];
          })
          .catch(() => {});
        return Promise.resolve(res.data);
      case axiosConfig.STATUS_CODE.NEED_ACCESS_CAPTCHA_PERMISSION: // 滑块验证
        console.warn("headers[Access-Captcha-Permission] is expired or missing, 需要执行滑块安全验证");
        const { captchaVerification } = await renderCaptcha({ withCredentials: false });
        Cookies.set("accessCaptchaPermission", captchaVerification || "", { domain: window.location.hostname });
        return omniAxios(config);
      /** code 为 503 **/
      case axiosConfig.STATUS_CODE.SERVER_ERR:
        Message.error(`网络错误，请稍后重试[SERVER_ERR ${code}]`);
        return Promise.reject(res.data);

      default:
        return Promise.reject(res.data);
    }
  } else {
    return Promise.reject(res.data);
  }
}

async function handleErrorResponse(response) {
  const httpCode = response && response.status;
  if (httpCode === axiosConfig.HTTP_CODE.REDO_LOGIN) {
    // 清除cookies
    clearCookies();
  }
  return Promise.reject(response);
}

/**
 * Axios二次封装
 * @param url 请求路径
 * @param method 请求方法
 * @param params 请求参数
 * @param timeout 超时时间，默认无超时时间，毫秒
 * @param apiType 接口分类
 * @param useDevServerProxy 开发阶段是否使用反向代理
 * @param withCredentials 是否携带身份认证
 * @param isFormData 入参是否为form表单
 * @returns {Promise<* | undefined>}
 */
export function omniAxios(config) {
  const {
    url,
    method = "get",
    params = {},
    withCredentials = true,
    timeout = 10000,
    apiType = axiosConfig.API_TYPE.API,
    useDevServerProxy = false,
    isFormData = false,
    headers = {},
  } = config;
  let baseURL = "";
  if (process.env.NODE_ENV === "development" && useDevServerProxy) {
    baseURL = PROXY_TYPE[apiType];
  } else {
    baseURL = process.env[`VUE_APP_API_${apiType}`];
  }
  console.log(headers,"headers");
  
  const axiosOptions = {
    baseURL,
    url,
    method,
    // withCredentials, // 确保请求携带cookie
    headers: {
      ...getHeaders(isFormData),
      ...headers,
    },
    timeout,
  };
  switch (method.toLowerCase()) {
    case "get":
      axiosOptions.params = params;
      break;
    case "post":
      axiosOptions.data = isFormData ? stringify(params) : params;
      break;
  }
  axios.defaults.withCredentials = withCredentials;
  return axios(axiosOptions)
    .then((res) => {
      return handleSuccessResponse(res, config);
    })
    .catch((e) => {
      return handleErrorResponse(e.response || e);
    });
}
